<template>
  <div class="login">
<!--    <canvas class="canvass"></canvas>-->
<!--    <div class="title">-->
<!--    </div>-->
    <div class="login-card">
      <div class="login-header">
        <div class="login-logo"></div>
        <div class="login-title">
          <div class="welcome">欢迎登录</div>
          <div class="system-name">培训视频平台</div>
<!--          <div class="system-desc">物联网预警 / 电梯维保 / AI识别 / 应急救援一站式解决方案</div>-->
        </div>
      </div>
      <a-form-model ref="loginForm" :model="formData" :rules="formRules" class="login-form normal-form">
        <a-form-model-item prop="username">
          <a-input v-model.trim="formData.username" placeholder="账户" size="large">
            <a-icon slot="prefix" type="user" style="color: #1890ff" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="password">
          <a-input v-model.trim="formData.password" type="password" placeholder="密码" size="large">
            <a-icon slot="prefix" type="lock" style="color: #1890ff" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="code">
          <div style="display: flex;">
            <a-input v-model.trim="formData.code" placeholder="验证码" size="large" style="flex: 1;">
              <a-icon slot="prefix" type="safety-certificate" style="color: #1890ff" />
            </a-input>
            <vertify-code ref="vertifyCode" @get-code="getVertifyCode" style="width: 123px;flex-shrink: 0;margin-left: 10px;"></vertify-code>
          </div>
        </a-form-model-item>
        <a-form-model-item>
          <a-checkbox :checked="formData.autologin" @change="formData.autologin=!formData.autologin" style="color: white">自动登录</a-checkbox>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" size="large" @click="checkFormData" style="width: 100%;">
            登录
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="compony-info"> Copyright © 2026 南京优湖科技有限公司 </div>
<!--    <div class="compony-info"><a href="https://beian.miit.gov.cn" target="_blank" style="color: white">湘ICP备2021017264-1</a>| Copyright © 2020 南京优湖科技有限公司 | 网址：www.esp-ulake.com</div>-->
  </div>
</template>
<script>
import { setCache, getCache } from '@/utils'
import {getUserByUserid, login} from 'A/login'
import VertifyCode from 'C/VertifyCode'
export default {
  name: 'login',
  components: {
    VertifyCode
  },
  data() {
    return {
      areaid:'',
      // userid:'',
      phonename:'',
      phonepassword:'',
      phonextnum:'',
      formData: {
        username: '',
        password: '',
        code: '',
        autologin: false
      },
      formRules: {
        username: [{required: true, message: '请输入账户'}],
        password: [{required: true, message: '请输入密码'}],
        code: [
          {required: true, message: '请输入验证码'},
          {
            validator: (rule, value, callback) => {
              if(value.toUpperCase() === this.vertifyCode.toUpperCase()) {
                callback();
              }else {
                callback('验证码错误')
              }
            }
          }
        ],
      },
      vertifyCode: '',
    }
  },
  mounted() {
  },
  created() {
    if(this.$route.params.flag==true){
      this.$router.go(0)
    }
    this.checkAutologin();
  },
  methods: {
    checkAutologin() {
      let logininfo = getCache('logininfo', true);
      if(logininfo) {
        this.formData.autologin = true;
        this.formData.username = logininfo.username;
        this.formData.password = logininfo.password;
        this.login();
      }
    },
    getVertifyCode(vertifyCode) {
      this.vertifyCode = vertifyCode;
    },
    checkFormData() {
      this.$refs.loginForm.validate(valid => {
        if(valid) {
          // 自动登录
          if(this.formData.autologin) {
            setCache('logininfo', {
              username: this.formData.username,
              password: this.formData.password,
            }, true);
          }
          this.login();
        }else {
          this.$refs.vertifyCode.refreshCode();
          return false;
        }
      })
    },
    login() {
      this.showLoading();
      let params = {
        useraccount: this.formData.username,
        password: this.formData.password,
        apptype: '1', // 0:app 1:pc
      }
      login(params).then(res => {
        if(res && res.returncode == '0') {
          this.userid = res.userid.toString();
          this.usertype = res.usertype;
          this.usernames = res.username;
          this.menuLists=res.menu
          // console.log(this.usertype)
          setCache('logininfo', {
            username: this.formData.username,
            password: this.formData.password,
            usersid: this.userid,
            usertype:this.usertype,
            usernames:this.usernames,
          }, true);
          this.$store.commit('setToken', 'platform '+res.token);
          this.$store.commit('setUserInfo', res);
          this.$store.commit('setMenuList', res.menu);
          getUserByUserid({userid:this.userid}).then(res=> {
            if (res && res.returncode == '0') {
              this.areaid=res.item.areaid
              this.phonename=res.item.phonename
              this.phonepassword=res.item.phonepassword
              this.phonextnum=res.item.phonextnum
              setCache('logininfo', {
                username: this.formData.username,
                password: this.formData.password,
                usersid: this.userid,
                usertype: this.usertype,
                usernames: this.usernames,
                areacode: this.areaid,
                phonename:this.phonename,
                phonepassword:this.phonepassword,
                phonextnum:this.phonextnum
              }, true);
              window.removeEventListener("load", window.setup);
              window.removeEventListener("resize", window.resize);
              window.removeEventListener("mousemove", window.mouseHandler);
              window.removeEventListener("mouseout", window.mouseHandler);
              setTimeout(function (){
                document.body.removeChild(window.canvas)
              },250)
              this.$router.push({
                name: 'home',
              })
            }
          })
        }else {
          this.$message.error(res.errormsg||'登录失败');
        }
        this.hideLoading();
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.canvass{
  position: absolute;
  overflow: hidden;
  z-index: -9999;
}
.login {
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: black;
  background-image: url('~@/assets/image/login.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.login-card {
  padding: 30px 50px;
  border-radius: 6px;
  //background-color: black;
  background: rgba(0,0,0,0.08);
  z-index: 1;
}
.login-header {
  display: flex;
  align-items: center;
  .login-logo {
    width: 44px;
    height: 45px;
    background-image: url('~@/assets/image/logo.png');
    background-size: 100% 100%;
  }
  .login-title {
    margin-left: 10px;
  }
  .welcome {
    line-height: 33px;
    color: rgba(255,255,255);
  }
  .system-name {
    font-size: 21px;
    line-height: 33px;
    color: rgba(255,255,255);
  }
  .system-desc {
    line-height: 22px;
    color: rgba(255,255,255,0.85);
  }
}
.login-form {
  margin-top: 30px;
  color: white;
  background-color:transparent
}
.compony-info {
  position: absolute;
  bottom: 20px;
  color: white;
  z-index: 1;
}
</style>